import { render, staticRenderFns } from "./DiversificationMeasureInfo.vue?vue&type=template&id=38b98be0&"
import script from "./DiversificationMeasureInfo.vue?vue&type=script&lang=js&"
export * from "./DiversificationMeasureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports